import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction'; // filter

import { FareBonusTypes, FareBonusInterface } from './types';

// List Fare Bonus
export const listFareBonusRequest = (payload: { body?: object }) =>
  action(FareBonusTypes.LIST_FARE_BONUS_REQUEST, payload);

export const listFareBonusSuccess = (payload: {
  fareBonusList: FareBonusInterface[];
  totalCount: number;
}) => action(FareBonusTypes.LIST_FARE_BONUS_SUCCESS, payload);

export const listFareBonusFailure = () =>
  action(FareBonusTypes.LIST_FARE_BONUS_FAILURE);

// Get Fare Bonus
export const getFareBonusRequest = (payload: object) =>
  action(FareBonusTypes.GET_FARE_BONUS_REQUEST, payload);

export const getFareBonusSuccess = (payload: {
  fareBonusData: FareBonusInterface;
}) => action(FareBonusTypes.GET_FARE_BONUS_SUCCESS, payload);

export const getFareBonusFailure = () =>
  action(FareBonusTypes.GET_FARE_BONUS_FAILURE);

// Get Fare Bonus
export const filterFareBonusRequest = (payload: object) =>
  asyncAction(FareBonusTypes.FILTER_FARE_BONUS_REQUEST, payload);

export const filterFareBonusSuccess = (payload: {
  fareBonusList: FareBonusInterface[];
  totalCount: number;
}) => action(FareBonusTypes.FILTER_FARE_BONUS_SUCCESS, payload);

export const filterFareBonusFailure = () =>
  action(FareBonusTypes.FILTER_FARE_BONUS_FAILURE);

// Create Fare Bonus
export const createFareBonusRequest = (payload: object) =>
  action(FareBonusTypes.CREATE_FARE_BONUS_REQUEST, payload);

export const createFareBonusSuccess = (payload: {
  fareBonusData: FareBonusInterface;
}) => action(FareBonusTypes.CREATE_FARE_BONUS_SUCCESS, payload);

export const createFareBonusFailure = () =>
  action(FareBonusTypes.CREATE_FARE_BONUS_FAILURE);

// Update Fare Bonus
export const updateFareBonusRequest = (payload: object) =>
  action(FareBonusTypes.UPDATE_FARE_BONUS_REQUEST, payload);

export const updateFareBonusSuccess = (payload: {
  fareBonusData: FareBonusInterface;
}) => action(FareBonusTypes.UPDATE_FARE_BONUS_SUCCESS, payload);

export const updateFareBonusFailure = () =>
  action(FareBonusTypes.UPDATE_FARE_BONUS_FAILURE);

// Delete Fare Bonus
export const deleteFareBonusRequest = (payload: object) =>
  action(FareBonusTypes.DELETE_FARE_BONUS_REQUEST, payload);

export const deleteFareBonusSuccess = () =>
  action(FareBonusTypes.DELETE_FARE_BONUS_SUCCESS);

export const deleteFareBonusFailure = () =>
  action(FareBonusTypes.DELETE_FARE_BONUS_FAILURE);
